import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/markets/company_settings/new/Page";

export const PATH = "/markets/company_settings/new";

function Home() {
	return (
		<>
			<NskHead title="修繕おまかせサービス 利用開始" />
			<Component />
		</>
	);
}

export default Home;
